import React from 'react';
import './styles.scss';

export default function PreviewLocation({
    location,
    locationClassName,
    isDisabled = false,
    onRemove
}) {
    return location
        ? makeLocationPreview(location, locationClassName, isDisabled, onRemove)
        : null;
}

function makeLocationPreview(
    location,
    locationClassName,
    isDisabled = false,
    onRemove
) {
    return (
        <div
            className={`PreviewLocation-location ${locationClassName}`}
            data-hook={'location'}
        >
            <div
                className={'PreviewLocation-locationName'}
                data-hook={'locationName'}
            >
                <strong>{location.name}</strong>
            </div>
            <div
                className={'PreviewLocation-locationAddress'}
                data-hook={'locationAddress'}
            >
                {location.address}
            </div>
            <div
                className={'PreviewLocation-locationPhoneNumber'}
                data-hook={'locationPhoneNumber'}
            >
                {location.phoneNumber}
            </div>
            {!isDisabled && (
                <button
                    className={'PreviewLocation-removeButton'}
                    type={'button'}
                    disabled={isDisabled}
                    onClick={onRemove}
                >
                    &times;
                </button>
            )}
        </div>
    );
}
